import React from 'react';

import { cityState } from 'helpers/formatters/address_formats';
import { isAssignment, isClosed, isLease, isLot, isUnderContract } from 'bundles/backoffice/vouchers/helpers/listings';

export default function buildRows(voucher) {
  const { details, listing } = voucher;

  if (isAssignment(voucher) && !isUnderContract(voucher) && !isClosed(voucher)) {
    return [];
  }

  let address2Label = 'Address 2';
  let address2Value = details.address2;
  if (isAssignment(voucher)) {
    address2Label = 'Lease Space';
    address2Value = listing?.closingLeaseSpace;
  } else if (isLot(voucher)) {
    address2Label = 'Lot Number';
    address2Value = details.lotNumber;
  } else if (isLease(voucher, { strict: true })) {
    address2Label = 'Space Name (Address 2)';
  }

  const rows = [
    {
      label: 'Property Name',
      value: details.propertyName,
    },
    {
      label: 'Address',
      value: buildAddress(details),
    },
    {
      label: 'Tenant Name',
      value: isAssignment(voucher) ? null : details.tenantName,
    },
    {
      label: address2Label,
      value: address2Value,
    },
    {
      label: 'Suite',
      value: details.suite,
    },
  ];

  return rows.filter(row => row.value);
}

function buildAddress(details) {
  const lines = [details.address, cityState(details), details.zip].filter(value => value);
  if (lines.length) {
    return lines.map((line, i) => (
      <React.Fragment key={i}>
        {i > 0 && <br/>}
        {line}
      </React.Fragment>
    ));
  } else {
    return null;
  }
}
